<ihd-modal class="c-modal--lg" [createOverlay]="false">
    <div class="c-modal__header">
        <div>
            {{ 'Order.UpdateAddress' | translate }}
        </div>
        <ihd-button-group class="ml-auto c-btn-group--gap-3">
            <button
                ihdIconButton
                icon="close"
                class="x-modal__icon-btn c-icon-btn--xs"
                (click)="close()"
            >
                <ihd-tooltip>{{ 'Common.Close' | translate }}</ihd-tooltip>
            </button>
        </ihd-button-group>
    </div>

    <div class="c-modal__body">
        <div
            class="c-modal__body-content"
            [formGroup]="addressForm"
            [ihdFormSubmitted]="submitted"
        >
            <strong>
                {{ 'Order.UpdateAddress.Title' | translate }}
            </strong>
            <div class="mb-3">
                {{ 'Order.UpdateAddress.Desc' | translate }}
            </div>
            <div class="c-form-group">
                <label>
                    {{ 'Order.UpdateAddress.SearchLocation' | translate }}
                </label>
                <ihd-google-autocomplete
                    formControlName="address"
                    ihdAutoFocus
                    [allowCustom]="false"
                ></ihd-google-autocomplete>
                <ihd-form-messages
                    [form]="addressForm"
                    name="address"
                    [submitted]="submitted"
                >
                    <ihd-form-message name="required">
                        {{
                            'HelpHint.Required'
                                | translate
                                    : {
                                          name:
                                              'Order.UpdateAddress.Required'
                                              | translate
                                      }
                        }}
                    </ihd-form-message>
                </ihd-form-messages>
            </div>
            <div class="c-modal__actions d-flex justify-content-end">
                <button
                    ihdButton
                    class="c-btn--primary c-btn--wmd c-btn--lg"
                    (click)="updateAddress()"
                    [disabled]="isBusy"
                >
                    {{ 'Order.UpdateAddress' | translate }}
                </button>
            </div>
        </div>
    </div>
</ihd-modal>
